module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("km5HQ"))).then(() => parcelRequire('iNCnh'));